import React from 'react'

const YourOrders = () => {
  return (
    <div>YourOrders</div>
  )
}

export default YourOrders